import {AgeCategoryService} from "crqlar-react-common/dist/services/ageCategory/ageCategory.service";
import {AgeCategoryType} from "crqlar-react-common/dist/models/ageCategory/ageCategory.model";

export interface DefaultAgeCategoryIds {
    adultsAgeCategoryId?: string
    childrenAgeCategoryId?: string
    teenagerAgeCategoryId?: string
    infantAgeCategoryId?: string
}

// Sorted by name ASC to match the age-category dropdown order, so the pre-selected
// value is the first option of its type the user would see in the list.
export const getDefaultAgeCategoryIds = async (): Promise<DefaultAgeCategoryIds> => {
    const ageCategories = (await AgeCategoryService.getAllAgeCategories({
        limit: {
            offset: 0,
            limit: 1000,
            sort: [{field: "name", direction: "ASC"}]
        }
    })).content || []

    const firstOfType = (type: AgeCategoryType) => ageCategories.find(c => c.type === type)?.id

    return {
        adultsAgeCategoryId: firstOfType(AgeCategoryType.ADULT),
        childrenAgeCategoryId: firstOfType(AgeCategoryType.CHILD),
        teenagerAgeCategoryId: firstOfType(AgeCategoryType.TEENAGER),
        infantAgeCategoryId: firstOfType(AgeCategoryType.INFANT),
    }
}
